import React from 'react'
import T from 'i18n-react';
import { InputLabel, Select, MenuItem, FormControl, FormControlLabel, Checkbox, Input } from "@material-ui/core";
import { mesStyles } from "../utility/ultrafabStyles";

const CheckForm = ({ maintenance, processCheck, onChange, vars }) => {
    const myClasses = mesStyles();

    return (
        <form className={myClasses.dialogForm} noValidate autoComplete="off">
            <FormControl margin="normal" fullWidth>
                <InputLabel htmlFor="name">{T.translate("processType.name")}</InputLabel>
                <Input name="name" value={processCheck ? processCheck.name : ""} autoFocus onChange={onChange} error={processCheck.name === ""} />
            </FormControl>
            <FormControl margin="normal" fullWidth>
                <InputLabel htmlFor="type">{T.translate("processType.check.type")}</InputLabel>
                <Select name="type" value={processCheck.type} onChange={onChange} error={processCheck.type === ""} >
                    <MenuItem value="boolean">{T.translate("function.boolean")}</MenuItem>
                    <MenuItem value="string">{T.translate("function.string")}</MenuItem>
                    <MenuItem value="number">{T.translate("function.number")}</MenuItem>
                    {!maintenance ? (
                        <MenuItem value="var">{T.translate("function.var").toLowerCase()}</MenuItem>
                    ) : null}
                    {!maintenance ? (
                        <MenuItem value="component">{T.translate("function.component").toLowerCase()}</MenuItem>
                    ) : null}
                </Select>
            </FormControl>
            {processCheck.type === "var" ? (
                <FormControl margin="normal" fullWidth>
                    <InputLabel htmlFor="varName">{T.translate("function.var")}</InputLabel>
                    <Select name="varName" onChange={onChange}
                        value={processCheck.varName !== "" && processCheck.varName !== null ? processCheck.varName : ""}
                        error={processCheck.varName === "" || processCheck.varName === null}>
                        {vars.map((v) => {
                            return (
                                <MenuItem key={v.id} value={v.name}>
                                    {v.name}
                                </MenuItem>
                            );
                        })}
                    </Select>
                </FormControl>
            ) : null}
            {!maintenance ? (
                <React.Fragment>
                    <FormControl margin="normal">
                        <FormControlLabel labelPlacement="end" control={<Checkbox color="primary" name="start" onChange={onChange} checked={processCheck.start} />}
                            label={T.translate("processType.check.start")} />
                    </FormControl>
                    <FormControl margin="normal">
                        <FormControlLabel labelPlacement="end" control={<Checkbox color="primary" name="pause" onChange={onChange} checked={processCheck.pause} />}
                            label={T.translate("processType.check.pause")} />
                    </FormControl>
                    <FormControl margin="normal">
                        <FormControlLabel labelPlacement="end" control={<Checkbox color="primary" name="restart" onChange={onChange} checked={processCheck.restart} />}
                            label={T.translate("processType.check.restart")} />
                    </FormControl>
                </React.Fragment>
            ) : null}
            <FormControl margin="normal">
                <FormControlLabel labelPlacement="end" control={<Checkbox color="primary" name="close" onChange={onChange} checked={processCheck.close} />}
                    label={T.translate("processType.check.close")} />
            </FormControl>
            {!maintenance ? (
                <FormControl margin="normal">
                    <FormControlLabel labelPlacement="end" control={<Checkbox color="primary" name="onDemand" onChange={onChange} checked={processCheck.onDemand} />}
                        label={T.translate("processType.check.onDemand")} />
                </FormControl>
            ) : null}
        </form>
    )
}

export default CheckForm;